import React from "react";
import Modal from "./Modal";
import "../../styling/UrgentDetailsModal.css"; // 👈 add this

function UrgentDetailsModal({ isOpen, onClose, urgentList = [], loading, formatDateTime }) {
  if (!isOpen) return null;
  console.log(urgentList);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Urgent Request History">
      <div className="urgent-details-modal">
        <div className="udm-body">
          {loading && <p className="udm-loading">Loading...</p>}

          {!loading && (!urgentList || urgentList.length === 0) && (
            <p className="udm-empty">No urgent requests found.</p>
          )}

          {!loading && urgentList?.length > 0 && (
                <div className="udm-card-list">
                    {urgentList.map((u) => (
                    <div className="udm-card" key={u.id}>
                        <div className="udm-card-header">
                        <div className="udm-stage">{u.stage}</div>
                        <span
                            className={`udm-status ${
                            u.approvalStatus === "APPROVED"
                                ? "approved"
                                : u.approvalStatus === "REJECTED"
                                ? "rejected"
                                : "pending"
                            }`}
                        >
                            {u.approvalStatus}
                        </span>
                        </div>

                        <div className="udm-card-body">
                        <div className="udm-row">
                            <span className="udm-label">Requested By</span>
                            <span>{u.requestedBy || "-"}</span>
                        </div>

                        <div className="udm-row">
                            <span className="udm-label">Created At</span>
                            <span>{formatDateTime(u.requestedAt)}</span>
                        </div>

                        <div className="udm-row">
                            <span className="udm-label">Completed By</span>
                            <span>{u.completedBy || "-"}</span>
                        </div>

                        <div className="udm-row">
                            <span className="udm-label">Completed At</span>
                            <span>{formatDateTime(u.completedDateTime)}</span>
                        </div>
                        </div>
                    </div>
                    ))}
                </div>
                )}
        </div>
      </div>
    </Modal>
  );
}

export default UrgentDetailsModal;